import api from "@/utils/api";

const state = {
  token: null,
  admin: {},
};

const mutations = {
  setToken(state, token) {
    state.token = token;
    localStorage.token = token;
  },
  setAdmin(state, admin) {
    state.admin = admin;
  },
  logout(state) {
    state.token = null;
    state.admin = null;
    localStorage.removeItem("token");
  },
};

const actions = {
  async getToken({ commit }, data) {
    commit("setLoading", "auth");
    const { access_token } = await api.post("/auth", data);
    commit("setToken", access_token);
    commit("unsetLoading", "auth");
  },
  async getAdmin({ commit }) {
    commit("setLoading", "admin");
    const { data: admin } = await api.get("/me");
    // Given than this is an admin endpoint, if we receive an email is an admin
    commit("setAdmin", admin?.email ? admin : null);
    commit("unsetLoading", "admin");
  },
  async setAdminDetails({ commit }, data) {
    commit("setLoading", "admin");
    await api.put("/me", data);
    commit("unsetLoading", "admin");
  },
  async setUserAsAdmin({ commit }, email) {
    commit("setLoading", "admin");
    await api.post("/admins", { email });
    commit("unsetLoading", "admin");
  },
  async setGoogleToken({ commit }, access_token) {
    commit("setToken", access_token);
  },
};

const getters = {
  token: (state) => localStorage.token || state.token,
  admin: (state) => state.admin,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
